<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<p class="author"><strong>DAVID FOSTER WALLACE</strong></p>
<h1 class="booktitle">GIRL WITH CURIOUS HAIR</h1>
<p class="img1"><img alt="Image" src="images/Little_full_new.jpg"/></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?7512e744